import React, { useEffect, useState } from 'react'
import { Layout, Flex, Select, Pagination } from 'antd';
import MyHeaderOne from '../header';
import MyFooter from '../footer';
import style from './page.module.less'
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { REQUEST_URL } from '../../utils/env';
import { Color } from 'antd/es/color-picker';

const { Header, Footer, Content } = Layout;

export default function Detail() {

    const [searchParams, setSearchParams] = useSearchParams();
    const ids = searchParams.get('id');
    const module = searchParams.get('show')

    const [info, setInfo] = useState()

    console.log(ids)
    console.log(module)

    const getInfo = async () => {
        console.log(module)
        try {
            const { data } = await axios.get(
                REQUEST_URL + '/info/getInfo',
                { params: { 'module': module, 'id': ids } }
            )
            console.log(data.data)
            setInfo(data.data)
        } catch (error) {
            throw new Error(error)
        }
    }

    const [hotYjcg, setHotYjcg] = useState()
    const getHotYJCG = async () => {
        try {
            const { data } = await axios.get(
                REQUEST_URL + '/info/getHotYJCG',
            )
            setHotYjcg(data)
        } catch (error) {
            throw new Error(error)
        }
    }

    const [column, setColumn] = useState()

    useEffect(() => {
        getInfo();
        getHotYJCG();
        if (module === 'jckb') {
            setColumn('动态监测快报')
        }
        if (module === 'yjcg') {
            setColumn('学术研究成果')
        }
        if (module === 'xxfb') {
            setColumn('信息发布')
        }
    }, [])

    return (
        <Layout className={style.details}>
            <Header className={style.details__header}>
                <MyHeaderOne />
            </Header>
            <Content className={style.details__wapper}>
                <Flex vertical={true} className={style.details__wapper__one} align='start'>
                    <Flex className={style.details__wapper__one__title}>{column} &gt; 文章详情</Flex>
                </Flex>
                <Flex vertical={false} align='start' className={style.details__wapper__two}>
                    {(info !== undefined) && <Flex vertical={true} className={style.details__wapper__two__left}>
                        <Flex className={style.details__wapper__two__left__title}>{info.title}</Flex>
                        <Flex vertical={false} wrap>
                            <Flex className={style.details__wapper__two__left__other}>所属栏目：{column}</Flex>
                            <Flex className={style.details__wapper__two__left__other}>创作类型：{info.create_type}</Flex>
                            <Flex className={style.details__wapper__two__left__other}>发布时间：{info.pub_date?.replace('-', '年').replace('-', '月') + '日'}</Flex>
                            {/* {(module === 'yjcg') && */}
                            {/* <Flex> */}
                            {(info.authors) && <Flex className={style.details__wapper__two__left__other}>文章作者：{info.authors}</Flex>}
                            {(info.corresponding) && <Flex className={style.details__wapper__two__left__other}>通讯作者：{info.corresponding}</Flex>}
                            {(info.aff) && <Flex className={style.details__wapper__two__left__other}>机构：{info.aff}</Flex>}
                            {(info.achievement) && <Flex className={style.details__wapper__two__left__other}>成果形式：{info.achievement}</Flex>}
                            {/* </Flex>
                            } */}
                        </Flex>
                        <Flex dangerouslySetInnerHTML={{ __html: info.html }} vertical={true} className={style.details__wapper__two__left__info}>

                        </Flex>
                        {(module === 'jckb') && <Flex vertical={true} align='flex-end' className={style.details__wapper__two__left__source}>
                            {(info.origin_editor) && <Flex align='flex-end' style={{ marginBottom: '5px', fontSize: '12px' }} vertical={true}>
                                <Flex style={{ marginBottom: '2px', textAlign: 'right' }}>原作者：
                                    <span>{info.origin_editor.join(', ')}</span>
                                </Flex>
                            </Flex>}
                            {(info.editor) && <Flex align='flex-end' style={{ marginBottom: '5px', fontSize: '12px' }} vertical={true}>
                                <Flex style={{ marginBottom: '2px', textAlign: 'right' }}>编辑/编译：
                                    <span>{info.editor.join(', ')}</span>
                                </Flex>
                            </Flex>}
                            {info.source_info.map((item, index) => {
                                return (
                                    <Flex align='flex-end' style={{ marginBottom: '10px', fontSize: '12px', width: '100%' }} vertical={true}>
                                        <Flex style={{ marginBottom: '2px', textAlign: 'right' }}>标题{info.source_info.length > 1 ? index + 1 : ''}：{item.title}</Flex>
                                        <Flex style={{ textAlign: 'right', maxWidth: '100%' }}><a style={{ color: '#666666', wordWrap: 'break-all' }} href={item.url}>来源{info.source_info.length > 1 ? index + 1 : ''}：{item.url}</a></Flex>
                                    </Flex>
                                )
                            })}

                        </Flex>}
                        {(module === 'xxfb') && <Flex className={style.details__wapper__two__left__source}>
                            {(info.source !== null) && <span style={{ marginRight: 33 }}>来源：{info.source}</span>}<a target='_blank' href={info.url}>点击查看原文</a>
                        </Flex>}
                        {(module === 'yjcg') && <Flex vertical={true} align='flex-end' className={style.details__wapper__two__left__source}>
                            {(info.publication) && <Flex style={{ marginBottom: '2px', textAlign: 'right' }}>出版信息：{info.publication}</Flex>}
                            <Flex style={{ textAlign: 'right' }}>引用权限：{info.CC}</Flex>
                        </Flex>}
                    </Flex>}
                    {(hotYjcg !== undefined) && <Flex vertical={true} className={style.kycg__wapper__two__right}>
                        <Flex className={style.kycg__wapper__two__right__title}>热门成果</Flex>
                        <Flex vertical={true} className={style.kycg__wapper__two__right__items}>
                            {hotYjcg.data.map((item, index) => {
                                return (
                                    <Flex vertical={true} className={style.kycg__wapper__two__right__item}>
                                        <Flex className={style.kycg__wapper__two__right__item__title}>
                                            <a target='_blank' href={(item.isUp === '是') ? `./detail?show=yjcg&id=${item.id}` : REQUEST_URL + `/stat/statCount?module=yjcg&id=${item.id}&url=${item.url}`}>{item.title}</a>
                                        </Flex>
                                        <Flex className={style.kycg__wapper__two__right__item__date_editor}>
                                            {item.pub_date}
                                        </Flex>
                                    </Flex>
                                )
                            })}
                        </Flex>
                    </Flex>}
                </Flex>
            </Content>
            <Footer className={style.details__footer}>
                <MyFooter />
            </Footer>
        </Layout >
    )
}
